import React from "react";
import { Box } from "@mui/material";
import { Footer, MainNav } from "@scoutingops/ui";

import { UserMenuButton } from "@/components/core/user-menu-button";
import { paths } from "@/paths";

export interface LayoutProps {
  children?: React.ReactNode;
}

export function Layout({ children }: LayoutProps): React.JSX.Element {
  return (
    <Box
      sx={{
        bgcolor: "background.default",
        color: "text.primary",
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
      }}
    >
      {/* brand and navUrls come from @scoutingops/ui's platform defaults.
          userMenu is passed explicitly because this app uses its own
          UserMenuButton rather than the shared one. */}
      <MainNav
        appHome={{ href: paths.studio, label: "Open Studio" }}
        userMenu={<UserMenuButton />}
      />
      <Box component="main" sx={{ flex: "1 1 auto" }}>
        {children}
      </Box>
      {/* Policy links resolve to the hub, which serves the platform's single
          set of policy pages — this app no longer hosts its own copies. */}
      <Footer />
    </Box>
  );
}
